import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  updateEpicDetails,
  updateCheckpoint,
  deleteEpic,
} from "../../../../sevices/apiEpic";

export const useMilestoneMutations = ({
  milestone,
  id,
  setShowEditor,
  handleClose,
  setSearchParams,
  searchParams,
  showToastPromise,
}) => {
  const queryClient = useQueryClient();

  const updateCardMutate = useMutation({
    mutationFn: async (data) => await showToastPromise(updateEpicDetails, data),
    onSuccess: (_, variables) => {
      // Only close editor if description was updated
      if (variables.data.description) {
        setShowEditor(false);
      }

      // Determine which queries to invalidate based on what was updated
      const updatedField = Object.keys(variables.data)[0];

      switch (updatedField) {
        case "start_date":
        case "target_release_date":
          // Only invalidate epic_id query for date updates
          queryClient.invalidateQueries({
            queryKey: ["epic_id", milestone],
          });
          break;

        case "description":
          // Invalidate epic_id and epic queries for description updates
          queryClient.invalidateQueries({
            queryKey: ["epic_id", milestone],
          });
          queryClient.invalidateQueries({
            queryKey: ["epic", `${id}`],
          });
          break;

        case "epic_name":
        case "completed":
          // Invalidate all queries for name and completion updates
          queryClient.invalidateQueries({
            queryKey: ["epic_id", milestone],
          });
          queryClient.invalidateQueries({
            queryKey: ["epic", `${id}`],
          });
          queryClient.invalidateQueries({
            queryKey: ["cards", id],
          });
          break;

        default:
          // For any other updates, invalidate all queries
          queryClient.invalidateQueries({
            queryKey: ["epic_id", milestone],
          });
          queryClient.invalidateQueries({
            queryKey: ["epic", `${id}`],
          });
          queryClient.invalidateQueries({
            queryKey: ["cards", id],
          });
      }
    },
  });

  const checkpointMutate = useMutation({
    mutationFn: updateCheckpoint,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["checkpoints", milestone],
      });
      queryClient.invalidateQueries({
        queryKey: ["boards"],
      });
    },
  });

  const deleteMutate = useMutation({
    mutationFn: async (data) => await showToastPromise(deleteEpic, data),
    onSuccess: () => {
      handleClose();
      const newSearchParams = new URLSearchParams(searchParams);
      newSearchParams.set("milestone", "");
      setSearchParams(newSearchParams);
      queryClient.invalidateQueries({
        queryKey: ["epic", id],
      });
    },
  });

  return {
    updateCardMutate: updateCardMutate.mutate,
    checkpointMutate: checkpointMutate.mutate,
    deleteMutate: deleteMutate.mutate,
  };
};
